var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","ripple":false,"color":"primary","small":!_vm.isMobile,"large":_vm.isMobile}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('Icon',{attrs:{"name":"exit-system","outline":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }